document.addEventListener("latte:init", init);

function init() {
    var p = $('.class-page').attr('data-productId'); //collects product id from class details page

    if (helper.getAddOn(p)) {
        var oldUrl = $('.js-add-on').attr('href');
        var newUrl = oldUrl + ',' + helper.getAddOn(p);

        $('.class-enroll-links a.btn').each(function () { //updates each button on page with appropriate add on product id
            if ($(this).attr('href') === oldUrl); {
                $(this).attr('href', newUrl);
            }
        });
    }

    $.urlParam = function (name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)')
            .exec(window.location.search);

        return (results !== null) ? results[1] || 0 : undefined;
    };

    var schedulerUrl = $.urlParam('ref');

    if (schedulerUrl !== undefined && schedulerUrl !== null && schedulerUrl !== '') {
        sessionStorage.setItem('showZipModal', false);
    }
}



//////////////////
// WEBPACK FOOTER
// ./public/js/class.js
// module id = 69
// module chunks = 0